'use es6';

import { buildSenderLocator } from 'conversations-message-history/senders/operators/buildSenderLocator';
import { getId, getType } from '../../responders/operators/responderKeyGetters';
export const getResponderKeyAsSenderLocator = responderKey => buildSenderLocator(getType(responderKey), getId(responderKey));